
import BaseButton from "@/components/base/BaseButton.vue";
import BaseCheckbox from "@/components/base/BaseCheckbox.vue";
import BaseInput from "@/components/base/BaseInput.vue";
import { UserType } from "@/models/enums";
import { ConfirmationEmail, confirmationEmailDialogKey } from "@/models/symbols/ConfirmationEmail";
import { useUserStore } from "@/store/user";
import useVuelidate from "@vuelidate/core";
import { email, helpers, required } from "@vuelidate/validators";
import { useEventBus } from "@vueuse/core";
import { computed, defineComponent, reactive, ref } from "vue";

export default defineComponent({
	components: {
		BaseButton,
		BaseCheckbox,
		BaseInput
	},
	setup() {
        const bus = useEventBus(confirmationEmailDialogKey);
		const show = ref(false);
		const loading = ref<boolean>(false);
		const data = ref<ConfirmationEmail>();
		const userStore = useUserStore();

		const isAgent = computed(() => userStore.getUser.type === UserType.Agent);

		bus.on((e) => {
			show.value = true;
			data.value = e;
		});

		const overlayClicked = (e: any) => {
			e.preventDefault();
			show.value = false;
		};

		const defaultEmail = computed(() => userStore.getUser.email);

		const submit = async () => {
			v$.value.$touch();
			const isValid = await v$.value.$validate();
			if (!isValid) {
				const firstError = (document as any).querySelector(
					".input-field__error"
				);
				if (firstError) {
					firstError.scrollIntoView({ block: "center", behavior: "smooth" });
				}
				
				return;
			}
			
			if(data.value?.callback) {
				loading.value = true;
				data.value.callback(state.email, state.pricedConfirmation)
				.finally(() => {
					show.value = false;
					loading.value = false;
				});
			}		
		};

		const state = reactive({
			pricedConfirmation: false,
			email: defaultEmail.value ?? ""
		});

		const rules = {
			pricedConfirmation: {},
			email: {
				v: helpers.withMessage(
					() => "Please enter your email address",
					required			
				),
				v2: helpers.withMessage(
					() => "Incorrect email format",
					email			
				),
			}, 
		};

		const v$ = useVuelidate(rules, state);

		return { 
			show, 
			data, 
			overlayClicked,
			loading,
			submit,
			isAgent,
			v$
		};
	},
});
